import React, { useMemo } from 'react';
export function StarField() {
  const stars = useMemo(() => {
    return Array.from({
      length: 50
    }).map((_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      size: Math.random() * 2 + 1 + 'px',
      animationDelay: `${Math.random() * 5}s`,
      animationDuration: `${Math.random() * 3 + 2}s`,
      opacity: Math.random() * 0.5 + 0.2
    }));
  }, []);
  return <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" data-id="element-195">
      {stars.map(star => <div key={star.id} className="absolute rounded-full bg-white animate-twinkle" style={{
      left: star.left,
      top: star.top,
      width: star.size,
      height: star.size,
      animationDelay: star.animationDelay,
      animationDuration: star.animationDuration,
      opacity: star.opacity
    }} data-id="element-196" />)}
    </div>;
}